/* Transform legacy WordPress shortcodes inside imported post content */
(function () {
    if (!document.body.classList.contains('post-template')) {
        return;
    }

    const content = document.querySelector('.post-template .gh-content');

    if (!content) {
        return;
    }

    function decodeHtml(value) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }

    function parseAttributes(shortcode) {
        const attrs = {};
        const attrPattern = /(\w+)=["“]([^"”]*)["”]/g;
        let match;

        while ((match = attrPattern.exec(shortcode)) !== null) {
            attrs[match[1]] = decodeHtml(match[2]);
        }

        return attrs;
    }

    function buildEmbedHtml(shortcode) {
        const attrs = parseAttributes(shortcode);
        const videoId = attrs.video;

        if (!videoId) {
            return '';
        }

        const width = Number(attrs.width) || 16;
        const height = Number(attrs.height) || 9;
        const ratio = (height / width) * 100;
        const searchParams = new URLSearchParams(attrs.parameters || '');

        if (!searchParams.has('rel')) {
            searchParams.set('rel', '0');
        }

        const src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + (searchParams.toString() ? '?' + searchParams.toString() : '');

        return [
            '<figure class="rv-shortcode-video">',
            '<div class="rv-shortcode-video-frame" style="padding-top:', ratio, '%;">',
            '<iframe src="', src, '" title="Embedded video" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
            '</div>',
            '</figure>'
        ].join('');
    }

    function buildBlockquoteHtml(shortcode, quoteContent) {
        const attrs = parseAttributes(shortcode);
        const author = (attrs.author || '').trim();
        const link = (attrs.link || '').trim();
        const target = (attrs.target || '').trim();
        const rel = target === '_blank' ? 'noopener noreferrer' : '';
        const quote = (quoteContent || '').trim();

        if (!quote) {
            return '';
        }

        const quoteBody = /^<p[\s>]/i.test(quote) ? quote : '<p>' + quote + '</p>';
        let footer = '';

        if (author) {
            const authorLabel = link
                ? '<a href="' + link + '"' + (target ? ' target="' + target + '"' : '') + (rel ? ' rel="' + rel + '"' : '') + '>' + author + '</a>'
                : author;

            footer = '<cite>' + authorLabel + '</cite>';
        }

        return [
            '<blockquote>',
            quoteBody,
            footer,
            '</blockquote>'
        ].join('');
    }

    function transformInlineVideoParagraphs(html) {
        return html.replace(/<p>\s*(\[video_embed\b[^\]]*\])\s*([\s\S]*?)<\/p>/gi, function (match, shortcode, trailingContent) {
            const embed = buildEmbedHtml(shortcode);
            const remainder = trailingContent.trim();

            if (!embed) {
                return match;
            }

            if (!remainder) {
                return embed;
            }

            return embed + '<p>' + remainder + '</p>';
        });
    }

    function transformStandaloneVideos(html) {
        return html.replace(/\[video_embed\b[^\]]*\]/gi, function (shortcode) {
            return buildEmbedHtml(shortcode) || shortcode;
        });
    }

    function transformBlockquotes(html) {
        return html.replace(/\[blockquote\b([^\]]*)\]([\s\S]*?)\[\/blockquote\]/gi, function (match, attrs, quoteContent) {
            return buildBlockquoteHtml('[blockquote' + attrs + ']', quoteContent) || match;
        });
    }

    function transformColumnShortcodes(html) {
        const startMarker = '<!--rv-one-second-start-->';
        const endMarker = '<!--rv-one-second-end-->';

        html = html
            .replace(/<p>\s*\[one_second\]\s*<\/p>/gi, startMarker)
            .replace(/<p>\s*\[\/one_second\]\s*<\/p>/gi, endMarker)
            .replace(/\[one_second\]/gi, startMarker)
            .replace(/\[\/one_second\]/gi, endMarker);

        html = html.replace(
            /<!--rv-one-second-start-->([\s\S]*?)<!--rv-one-second-end-->\s*<!--rv-one-second-start-->([\s\S]*?)<!--rv-one-second-end-->/gi,
            function (match, firstColumn, secondColumn) {
                return [
                    '<div class="rv-shortcode-columns">',
                    '<div class="rv-shortcode-column is-body">', firstColumn.trim(), '</div>',
                    '<div class="rv-shortcode-column is-body">', secondColumn.trim(), '</div>',
                    '</div>'
                ].join('');
            }
        );

        html = html.replace(
            /<!--rv-one-second-start-->([\s\S]*?)<!--rv-one-second-start-->([\s\S]*?)<!--rv-one-second-end-->/gi,
            function (match, firstColumn, secondColumn) {
                return [
                    '<div class="rv-shortcode-columns">',
                    '<div class="rv-shortcode-column is-body">', firstColumn.trim(), '</div>',
                    '<div class="rv-shortcode-column is-body">', secondColumn.trim(), '</div>',
                    '</div>'
                ].join('');
            }
        );

        return html
            .replace(/<!--rv-one-second-start-->|<!--rv-one-second-end-->/gi, '')
            .replace(/<p>\s*<\/p>/gi, '');
    }

    const originalHtml = content.innerHTML;
    const transformedHtml = transformColumnShortcodes(transformBlockquotes(transformStandaloneVideos(transformInlineVideoParagraphs(originalHtml))));

    if (transformedHtml !== originalHtml) {
        content.innerHTML = transformedHtml;
    }
})();
